import { Instance, resolveIdentifier } from 'mobx-state-tree';
import { RouteDtoModel } from '.';
import getAppRoot from '../utils/getAppRoot';
import { RouteDtoModelType } from './RouteDtoModel';
import { SolutionStatusOnlyDtoModelBase } from './SolutionStatusOnlyDtoModel.base';

/* The TypeScript type of an instance of SolutionStatusOnlyDtoModel */
export interface SolutionStatusOnlyDtoModelType extends Instance<typeof SolutionStatusOnlyDtoModel.Type> {}

/* A graphql query fragment builders for SolutionStatusOnlyDtoModel */
export { selectFromSolutionStatusOnlyDto, solutionStatusOnlyDtoModelPrimitives, SolutionStatusOnlyDtoModelSelector } from './SolutionStatusOnlyDtoModel.base';

/**
 * SolutionStatusOnlyDtoModel
 */
export const SolutionStatusOnlyDtoModel = SolutionStatusOnlyDtoModelBase
  .views((self) => ({
    get targetRoute(): RouteDtoModelType | undefined {
      return self.actionType === 'optimize_assign' && self.assignAction && self.assignAction.targetRouteId != null ? resolveIdentifier(RouteDtoModel, getAppRoot(self), self.assignAction.targetRouteId) : undefined;
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
